import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

export type Route = {
  path: string;
  query: string;
};

@customElement('ltn-router')
export class LtnRouter extends LitElement {
  private __path?: string;

  private __query?: string;

  private __route: Route = { path: '', query: '' };

  private __urlChangedEventHandler?: EventListener;

  // private __subscriptions: {[index: string]: Function} = {};

  connectedCallback(): void {
    super.connectedCallback();

    this.__path = window.decodeURIComponent(window.location.pathname);
    this.__query = window.location.search.slice(1);
    this.__route = { path: this.__path, query: this.__query };

    this.__urlChangedEventHandler = () => this._urlChanged();

    window.addEventListener('location-changed', this.__urlChangedEventHandler);
    window.addEventListener('popstate', this.__urlChangedEventHandler);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    if (this.__urlChangedEventHandler) {
      window.removeEventListener('location-changed', this.__urlChangedEventHandler);
      window.removeEventListener('popstate', this.__urlChangedEventHandler);
    }
  }

  // subscribe(cb: Function) {
  //   const id = uuidv4();
  //   this.__subscriptions[id] = cb;
  //   return id;
  // }

  // unsubscribe(id: string): void {
  //   if (this.__subscriptions[id]) delete this.__subscriptions[id];
  // }

  get route(): Route {
    return this.__route;
  }

  private _urlChanged() {
    this.__path = window.decodeURIComponent(window.location.pathname);
    this.__query = window.location.search.slice(1);

    if (this.__route && this.__route.path === this.__path && this.__query === this.__route.query) {
      return;
    }

    this.__route = { path: this.__path, query: this.__query };

    this.dispatchEvent(
      new CustomEvent('route-changed', {
        detail: this.__route,
        bubbles: true,
        composed: true,
      }),
    );
  }
}
